import React from "react";
import DenseAppBar from "../../components/AppBar";
import PrimaryTheme from "../../Themes/Primary";
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Avatar, Grid } from "@material-ui/core";
import { deepPurple } from "@material-ui/core/colors";
import { useDispatch, useSelector } from "react-redux";
import { Reducers } from '../../Interfaces/Interfaces'
// import { useHistory } from "react-router-dom";
// import { useSnackbar } from "notistack";
import { getUserPaged } from "../../redux/actions/NotificationActions";
import Placeholder from "../../components/Skeleton";
import { getDateTime } from "../../helpers/Functions";
import "./notification.scss"
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',


    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
      color: PrimaryTheme.primary,
      fontFamily: PrimaryTheme.fonts?.BoldFont,
      marginLeft: "30px"
    },
    paper: {
      padding: theme.spacing(2),

      color: theme.palette.text.secondary,
    },
    orange: {
      color: theme.palette.getContrastText(deepPurple[500]),
      backgroundColor: deepPurple[500],
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
  }),
);

export default function Notifications() {
  const classes = useStyles();
  const notification = useSelector((state: Reducers) => state.notification);
  const user = useSelector((state: Reducers) => state.user);
  const dispatch = useDispatch();

  // const [] = React.useState('');
  const [state] = React.useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  let list = notification && notification.items;
  const [page] = React.useState(0);
  const [pageSize] = React.useState(10);




  let filter: any = {
    //...state
  };
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.userId,
    whereCondition: JSON.stringify(filter)
  }

  React.useEffect(() => {
    dispatch({
      type: 'LOADING',
      payload: true
    });

    dispatch(getUserPaged(paginationConfig));




    return () => {
      dispatch({
        type: "NOTIFICATION",
        payload: {}
      });



    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="col-md-11 mr-auto ml-auto p-0" style={{
        height: 'auto',
        position: "relative",
      }}>
        <DenseAppBar />
      </div>

      <div className='col-md-12 pl-0 pr-0' style={{
        // overflow: "auto",
        backgroundColor: PrimaryTheme.white,
        // height: '100vh',
      }}>

        <div className="col-md-11 ml-auto mr-auto p-0" style={{
          backgroundColor: PrimaryTheme.white,
          height: '100vh',
          position: 'relative',
        }}>

          <div className="row mb-5">
            <div className="col-md-9 col-6 notification-title">
              <h4 style={{
                fontFamily: PrimaryTheme.fonts?.BoldFont
              }}>NOTIFICATIONS</h4>

              <h6 style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                color: PrimaryTheme.light,
              }}>View all Notifications</h6>
            </div>

          </div>

          <div className={classes.root}>

            {notification ? (
              <React.Fragment>
                <Accordion>
                  <AccordionSummary
                    style={
                      {
                        flexDirection: 'row-reverse',
                        color: PrimaryTheme.primary + "!important",


                      }
                    }
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"

                  >
                    <Typography className={classes.heading}>Today ({notification.total})</Typography>
                  </AccordionSummary>
                  {notification.length !== 0 && list?.map((item: any) => (

                    <AccordionDetails className="shadow" style={{
                      backgroundColor: '#c3e4f6',
                      margin: "0px",
                      marginBottom: "1px",

                    }}>



                      <Grid container spacing={2} style={{
                        borderBottomColor: "red"
                      }}>
                        <Grid item xs={11}>

                          <div className="row ml-2" >


                            <Avatar src={item.imageUrl} ></Avatar>
                            <div className="col-6 mt-1">
                              <div className='row'>
                                <div className="col-12 ">{item.title}</div>
                                <div className="col-12" style={{

                                  color: PrimaryTheme.light,
                                }}>{item.body}</div>

                              </div>


                            </div>


                          </div>

                        </Grid>

                        <Grid item xs={1}>
                          <p className="mt-3 mb-3" style={{

                            color: PrimaryTheme.light,
                          }}>{getDateTime(item.dateCreated)}</p>
                        </Grid>


                      </Grid>







                    </AccordionDetails>


                  ))}

                  {notification.total === 0 &&
                    <React.Fragment>
                      <p className='text-center mt-3 text-dark w-100'>No active notification </p>
                    </React.Fragment>

                  }
                </Accordion>

              </React.Fragment>
            ) :
              (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />

                  </div>

                </React.Fragment>
              )}


          </div>

        </div>




      </div>

    </React.Fragment>
  );
}
